import { useQuery } from "@tanstack/react-query";
import styles from "./style.module.scss";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";

export default function RecentPostsMobile({
    links,
}: {
    links: { title: string | null; link: string }[];
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className="lg:hidden  mt-24 ">
            <h3 className={`text-xl font-bold mb-4`}>
                {translate(translations, "several_general_recentPosts")}
            </h3>
            <div className={`${styles["linksList"]}   `}>
                {links?.map((el, index) => (
                    <div
                        key={index}
                        className={`${styles["bulletedListItem"]} pl-5  rtl:pr-4 before:rtl:right-[5px] before:ltr:left-[5px] pb-3  `}
                    >
                        <a
                            href={el?.link ?? "#"}
                            dangerouslySetInnerHTML={{
                                __html: el?.title as string,
                            }}
                            className={`${styles["linkColor"]}  before:rtl:right-[2px] before:ltr:left-[2px] block  cursor-pointer text-sm `}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
